import React, {Component} from 'react'

export default class Image extends Component {
  render() {
    let {
      className,
      src,
      alt
    } = this.props
    if(!src) return null

    alt = alt || ''
    className = className || ''

    return (
      <img
        className={`${className} lazyload`}
        data-sizes="auto"
        data-srcset={src}
        alt={alt} />
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Common/Image.js